import { ORDERBOOK_DISPLAY_TYPE } from './useOrderbookDisplayPreference';
import { OrderbookGroupSizeSelector } from './OrderbookGroupSizeSelector';
import { CUMULATIVE_SIZE_CURRENCY } from '@velocity-exchange/common';
import { OrderbookGrouping } from '@velocity-exchange/common';
import { OrderbookCurrencySwitch } from './OrderbookCurrencySwitch';
import { memo, useMemo } from 'react';

interface Props {
	displayType: ORDERBOOK_DISPLAY_TYPE;
	marketSymbol: string;
	groupingSizeOptions: {
		value: OrderbookGrouping;
		label: string;
	}[];
	onGroupSizeChange: (value: number) => void;
	groupingSelection: number;
	cumulativeSizeCurrency: CUMULATIVE_SIZE_CURRENCY;
	onCurrencyChange: (currency: CUMULATIVE_SIZE_CURRENCY) => void;
	isLoading: boolean;
	isMini?: boolean;
}

const OrderbookTableHeader = ({
	displayType,
	marketSymbol,
	groupingSizeOptions,
	onGroupSizeChange,
	groupingSelection,
	cumulativeSizeCurrency,
	onCurrencyChange,
	isLoading,
	isMini,
}: Props) => {
	const currencySelectorOptions = useMemo(() => {
		return [
			{ value: CUMULATIVE_SIZE_CURRENCY.USD, label: 'USD' },
			{ value: CUMULATIVE_SIZE_CURRENCY.BASE, label: marketSymbol },
		];
	}, [marketSymbol]);

	const sizeLabel =
		cumulativeSizeCurrency === CUMULATIVE_SIZE_CURRENCY.USD
			? 'USD'
			: marketSymbol;

	return (
		<div className="flex flex-col gap-sm bg-container-bg p-sm">
			<div className="flex items-center justify-between">
				<OrderbookGroupSizeSelector
					options={groupingSizeOptions}
					onChange={onGroupSizeChange}
					value={groupingSelection}
					isLoading={isLoading}
				/>

				<OrderbookCurrencySwitch
					options={currencySelectorOptions}
					value={cumulativeSizeCurrency}
					onChange={onCurrencyChange}
					isMini={isMini}
				/>
			</div>

			<div className="flex justify-between typo-body-2xs text-text-tertiary">
				{displayType === ORDERBOOK_DISPLAY_TYPE.HORIZONTAL ? (
					<>
						<span className="text-left">Size ({sizeLabel})</span>
						<span className="text-center">Price</span>
						<span className="text-right">Size ({sizeLabel})</span>
					</>
				) : (
					<>
						<span className="flex-1 text-left">Price</span>
						<span className="flex-2 text-right">
							Size {!isMini && `(${sizeLabel})`}
						</span>
						{!isMini && (
							<span className="flex-2 text-right">Total ({sizeLabel})</span>
						)}
					</>
				)}
			</div>
		</div>
	);
};

export default memo(OrderbookTableHeader);
